<template>
    <vue-select
        :value="value"
        :options="options()"
        :get-option-label="(option) => { return option.name }"
        :size="size"
        :reduce="v => v"
        :filter="filterOption"
        :selectable="(option) => { return !option.header }"
        @input="input"
        placeholder="手動入力"

        append-to-body
        :calculate-position="withPopper"
        >
        <template #option="{ type, id, name, header, }">
            <span v-if="header">{{ header }}</span>
            <span v-else-if="type === 'item'">{{ name }}</span>
            <span v-else class="ms-3">{{ name }}</span>
        </template>
    </vue-select>
</template>

<script>
import Fuse from 'fuse.js'
import { createPopper } from '@popperjs/core'

export default {
    components: {
    },
    props: {
        value: {
            type: Object,
            required: false,
            default() {
                return null
            },
        },
        size: {
            type: String,
            required: false,
            default: 'sm',
        },
    },
    data() {
        return {
            headers: {
                item: '内容物',
                hscode: 'HSコード/原産国',
            }
        }
    },
    computed: {},
    async mounted() {},
    methods: {
        options() {
            const options = []
            // item
            options.push(...this.$store.state.app.data.shipping_items.map((v) => {
                v.type = 'item'
                return v
            }))
            // hscode
            options.push(...this.$store.state.app.data.shipping_hscodes.map((v) => {
                v.type = 'hscode'
                return v
            }))

            const options_final = JSON.parse(JSON.stringify(options))
            return this.addHeader(options_final.map((v) => {
                v.id = v.type + '.' + v.id
                return v
            }))
        },
        addHeader(options) {
            const points = []
            if (options.length > 0) {
                points.push(0)
            }
            for (let i = 1; i < options.length; i++) {
                if (options[i - 1].type !== options[i].type) {
                    points.push(i)
                }
            }
            for (let i = points.length - 1; i >= 0; i--) {
                options.splice(points[i], 0, { header: this.headers[options[points[i]].type], })
            }
            return options
        },
        filterOption(options, search) {
            const fuse = new Fuse(options, {
                keys: [ 'name', ],
                shouldSort: true,

                tokenize: true,
//                ignoreLocation: true,

                includeMatches: true,
                minMatchCharLength: 1,
                threshold: 0.9,
            })
//setTimeout(() => {
//    const dropdownList = document.querySelector('ul.vs__dropdown-menu')
//    if (dropdownList) {
//        console.log(dropdownList.scrollTop = 0)
//    }
//} , 1)
            const ret = search.length
                ? fuse.search(search).map(({ item }) => item)
                : fuse.list
            return this.addHeader(ret)
        },
        input(value) {
            this.$emit('input', value)
        },

        withPopper(dropdownList, component, { width }) {
            /**
             * We need to explicitly define the dropdown width since
             * it is usually inherited from the parent with CSS.
             */
            dropdownList.style.width = width
            dropdownList.style.height = '350px'

            /**
             * Here we position the dropdownList relative to the $refs.toggle Element.
             *
             * The 'offset' modifier aligns the dropdown so that the $refs.toggle and
             * the dropdownList overlap by 1 pixel.
             *
             * The 'toggleClass' modifier adds a 'drop-up' class to the Vue Select
             * wrapper so that we can set some styles for when the dropdown is placed
             * above.
             */
            const vm = this
            const popper = createPopper(component.$refs.toggle, dropdownList, {
                placement: 'bottom',
                modifiers: [
                    {
                        name: 'offset',
                        options: {
                            offset: [0, -1],
                        },
                    },
                    {
                        name: 'toggleClass',
                        enabled: true,
                        phase: 'write',
                        fn({ state }) {
                            component.$el.classList.toggle(
                                'drop-up',
                                state.placement === 'top'
                            )
                        },
                    },
                ],
            })
            
            /**
             * To prevent memory leaks Popper needs to be destroyed.
             * If you return function, it will be called just before dropdown is removed from DOM.
             */
            return () => popper.destroy()
        },
    },
}
</script>

<style>
.v-select.drop-up.vs--open .vs__dropdown-toggle {
    border-radius: 0 0 4px 4px;
    border-top-color: transparent;
    border-bottom-color: rgba(60, 60, 60, 0.26);
}

[data-popper-placement='top'] {
    border-radius: 4px 4px 0 0;
    border-top-style: solid;
    border-bottom-style: none;
    box-shadow: 0 -3px 6px rgba(0, 0, 0, 0.15);
}
</style>

<style>
.vs__dropdown-menu {
    z-index: 2000;
}
</style>

